export default {
  namespaced: true,
  state: {
    tree: {},
  },
}
